<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <div class="wj-labeled-input attr-text" :style="attr.cssStyle||'max-width: 25rem !important;'" v-wjTooltip="tooltip()"
            @contextmenu.prevent="ctxOpen($event)">
            <!-- IE 2026 08 28 / ODOO-5828 (заказ Игоря): «список значений» — CSV-значение чипсами с тайтлами,
                 проваливание в запись, добавление через ввод с подсказками; включается правым кликом -->
            <div v-if="asList" class="attr-element attr-vlist" :class="attr.cssClass" :id="attr.html_id">
                <span v-for="(v, i) in listValues" :key="i" class="vlist-chip" :title="v" @click="drill(v)">
                    <span class="vlist-chip-text">{{ valTitle(v) }}</span>
                    <i v-if="!isReadOnly" class="pi pi-times-circle vlist-chip-x" @click.stop="removeVal(i)"></i>
                </span>
                <span v-if="!isReadOnly" class="vlist-add">
                    <input class="vlist-input" v-model="addText" placeholder="+"
                        @focus="dropOpen = true" @blur="dropClose()"
                        @keydown.enter.prevent="addRaw()" @keydown.esc="dropOpen = false" />
                    <div v-if="dropOpen && dropItems.length" class="vlist-drop">
                        <div v-for="it in dropItems" :key="it.id" class="vlist-drop-item"
                            @mousedown.prevent="addVal(it.id)">{{ it.title || it.id }}</div>
                    </div>
                </span>
            </div>
            <!-- IE 2026 11 03 / ODOO-349799 (placeholder): the hint of the view attribute (attr.placeholder) goes to the input of the combo box -->
            <wj-combo-box v-else
                :class="'attr-element '+attr.cssClass"
                :id="attr.html_id"
                :isEditable="true"
                :isReadOnly="isReadOnly"
                :type="attr['input-type']"
                :placeholder="attr.placeholder || ''"
                v-model:text="doc[binding]"
                :textChanged="attr_set"
                v-wjContextMenu="'ContextWidgetMenuId'"
            />
                <!-- autocomplete="name"  -->
                <!-- required -->
            <label v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>
            <div v-if="attr['wj-error']" class="wj-error" tabindex="-1">{{ attr['wj-error'] }}</div>
            <div v-if="ctx.show" class="vlist-ctx" :style="{ left: ctx.x + 'px', top: ctx.y + 'px' }"
                @mouseleave="ctx.show = false">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="vlist-ctx-item" @click="toggleList()">{{ asList ? t('Present as plain text') : t('Present as a value list') }}</div>
            </div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'

export default {
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({ 
        WIDGET: {},
        doc: {},
        binding: '',
        addText: '',
        dropOpen: false,
        ctx: { show: false, x: 0, y: 0 },
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    methods: {
        content_Changed() {
            this.store.widget_attr_set(this)
        
            // this.text = this.store.attr_get(this.WIDGET, this.attr)
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
            this.doc = doc, this.binding = binding
        },
        attr_set(input) {
            if (this.doc[this.binding] !== input.text) {
                this.store.attr_set(this.WIDGET, this.attr, input.text)
            }
        },
        tooltip() {
            return this.store.tooltip_attr(this)
        },
        // ---- IE 2026 08 28 / ODOO-5828: режим «список значений» ----
        ctxOpen(e) {
            this.ctx = { show: true, x: e.clientX, y: e.clientY }
        },
        toggleList() {
            this.ctx.show = false
            const b = this.attr?.binding
            if (b == null) return
            this.store.set_viewParam(this.WIDGET, 'value_as_list', b, !this.asList)
        },
        valTitle(v) {
            const it = this.listItems.find(x => String(x.id) === String(v))
            return it ? (it.title || v) : v
        },
        applyList(arr) {
            const csv = arr.join(',')
            if ((this.doc?.[this.binding] ?? '') !== csv) {
                this.store.attr_set(this.WIDGET, this.attr, csv)
            }
        },
        removeVal(i) {
            const arr = this.listValues.slice()
            arr.splice(i, 1)
            this.applyList(arr)
        },
        addVal(id) {
            id = String(id ?? '').trim()
            if (!id) return
            const arr = this.listValues.slice()
            if (!arr.includes(id)) arr.push(id)
            this.applyList(arr)
            this.addText = ''
            this.dropOpen = false
        },
        addRaw() {
            const t = this.addText.trim()
            if (!t) return
            const it = this.dropItems[0]
            this.addVal(it ? it.id : t)
        },
        dropClose() {
            setTimeout(() => { this.dropOpen = false }, this.store?.setting('fe.ux.hoverHideMs', 150) ?? 150)   // IE 2026 09 05 / ODOO-336330
        },
        drill(v) {
            const it = this.listItems.find(x => String(x.id) === String(v))
            const seg = it?.segment || this.attr?.relation_segment
            if (!seg) return
            this.store.widget_open({
                doc: { id: v, segment: seg },
                widget: 'widget-record',
                parentAction: { 'action_name': 'action-front-vlist', method: 'AttrStr.drill' },
            }, this)
        },
    },
	computed: {
        isReadOnly() {
            return this.WIDGET?.isReadOnly||this.attr?.isReadOnly||this.attr?.fieldMapping?.use||false
        },
        asList() {
            const b = this.attr?.binding
            const vp = this.WIDGET?.record?.doc?.viewParams?.value_as_list
            const f = (vp && b != null) ? vp[b] : undefined
            if (f !== undefined) return !!f
            // IE 2026 08 28 / ODOO-5828 (заказ Игоря): несколько значений — чипсами по умолчанию
            return !!this.attr?.as_list || this.listValues.length > 1
        },
        listValues() {
            return String(this.doc?.[this.binding] ?? '').split(',').map(s => s.trim()).filter(Boolean)
        },
        listItems() {
            return (this.attr?.itemsSource || []).filter(x => x && x.id != null)
        },
        dropItems() {
            const t = this.addText.trim().toLowerCase()
            const have = this.listValues
            return this.listItems
                .filter(x => !have.includes(String(x.id)))
                .filter(x => !t || String(x.title || '').toLowerCase().includes(t) || String(x.id).toLowerCase().includes(t))
                .slice(0, 12)
        },
	},
}
</script>

<style scoped>
.attr-text {
    width:-webkit-fill-available !important;
}
/* IE 2026 08 28 / ODOO-5828: список значений */
.attr-vlist {
    display: flex; flex-wrap: wrap; align-items: center; gap: 3px;
    min-height: 1.6rem; padding: 2px 0 1px 0;
    border-bottom: 1px solid var(--surface-border, #cbd5e1);
}
.vlist-chip {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 1px 7px; border-radius: 10px; cursor: pointer;
    background: var(--highlight-bg, #eef2ff); border: 1px solid var(--surface-border, #c7d2fe);
    font-size: .85em; line-height: 1.35; max-width: 14rem;
}
.vlist-chip-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.vlist-chip-x { font-size: .85em; opacity: .55; }
.vlist-chip-x:hover { opacity: 1; }
.vlist-add { position: relative; flex: 1 0 3rem; min-width: 3rem; }
.vlist-input {
    width: 100%; border: none; outline: none; background: transparent;
    font: inherit; color: inherit; padding: 2px 2px;
}
.vlist-drop {
    position: absolute; left: 0; top: 100%; z-index: 1000; min-width: 12rem; max-height: 16rem; overflow-y: auto;
    background: var(--surface-card, #fff); border: 1px solid var(--surface-border, #cbd5e1);
    border-radius: 4px; box-shadow: 0 4px 14px rgba(0,0,0,.18);
}
.vlist-drop-item { padding: 4px 10px; cursor: pointer; white-space: nowrap; }
.vlist-drop-item:hover { background: var(--highlight-bg, #eef2ff); }
.vlist-ctx {
    position: fixed; z-index: 10000;
    background: var(--surface-card, #fff); border: 1px solid var(--surface-border, #cbd5e1);
    border-radius: 4px; box-shadow: 0 4px 14px rgba(0,0,0,.18); padding: 2px;
}
.vlist-ctx-item { padding: 4px 12px; cursor: pointer; white-space: nowrap; font-size: .9em; }
.vlist-ctx-item:hover { background: var(--highlight-bg, #eef2ff); }
</style>